var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pb-5 my-4"},[_c('div',{staticClass:"container mb-3"},[_c('ChooseAmount'),_c('br'),_c('CustomDonation'),_c('br'),_c('PaymentMethod'),_c('br'),_c('Information'),_c('br'),_c('Disclaimer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }